import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SimpleGalleryComponent } from './simple-gallery.component';
import { CmsConfig, I18nModule, provideConfig } from '@spartacus/core';
import { SimpleThumbsComponent } from './components/simple-thumbs/simple-thumbs.component';
import { CarouselModule as PrimeCarousel } from 'primeng/carousel';
import { IframeModule } from '../../store-front/misc/cms-components/iframe/iframe.module';
import { SimpleViewerImageModalComponent } from './components/simple-viewer-image-modal/simple-viewer-image-modal.component';
import { Magic360Component } from '../../../../components/magic-360/magic-360.component';
import { CustomMediaModule } from '../../store-front/misc/media/media.module';

@NgModule({
  declarations: [SimpleGalleryComponent, SimpleThumbsComponent, SimpleViewerImageModalComponent],
  imports: [CommonModule, CustomMediaModule, PrimeCarousel, I18nModule, IframeModule, Magic360Component],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        SimpleGallery: {
          component: SimpleGalleryComponent,
        },
      },
    }),
  ],
})
export class SimpleGalleryModule {}
